import React from 'react';
import { ArrowRight, Leaf } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-white to-blue-50"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-orange-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-sm border border-orange-200">
              <Leaf className="w-4 h-4 text-green-600" />
              <span className="text-sm font-medium text-gray-700">Sustainable Mandarin Processing</span>
            </div>

            <div className="space-y-6">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Deep Mandarin
                <span className="block mt-2 bg-gradient-to-r from-orange-600 to-orange-500 bg-clip-text text-transparent">
                  Processing Excellence
                </span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                Transforming premium Croatian mandarins into high-quality products through advanced deep processing technology.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={scrollToContact}
                className="group px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
              >
                Get In Touch
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-4 bg-white text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all shadow-md hover:shadow-lg border border-gray-200"
              >
                Our Products
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div>
                <div className="text-3xl font-bold bg-gradient-to-r from-orange-600 to-orange-500 bg-clip-text text-transparent">100%</div>
                <div className="text-sm text-gray-600 mt-1">Natural</div>
              </div>
              <div>
                <div className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-blue-500 bg-clip-text text-transparent">Croatia</div>
                <div className="text-sm text-gray-600 mt-1">Based</div>
              </div>
              <div>
                <div className="text-3xl font-bold bg-gradient-to-r from-green-600 to-green-500 bg-clip-text text-transparent">Premium</div>
                <div className="text-sm text-gray-600 mt-1">Quality</div>
              </div>
            </div>
          </div>

          {/* Right Column - Visual Element */}
          <div className="relative">
            <div className="relative z-10">
              {/* Decorative mandarin circles */}
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-orange-400 to-orange-500 rounded-3xl p-12 shadow-2xl transform hover:scale-105 transition-transform">
                  <div className="text-white">
                    <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4 backdrop-blur-sm">
                      <Leaf className="w-8 h-8" />
                    </div>
                    <h3 className="text-2xl font-bold mb-2">Pure</h3>
                    <p className="text-orange-100">Natural mandarin processing</p>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl p-12 shadow-2xl transform hover:scale-105 transition-transform mt-12">
                  <div className="text-white">
                    <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4 backdrop-blur-sm">
                      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 18c-3.87-1.08-7-5.37-7-9.5V8.5l7-3.5 7 3.5v5.5c0 4.13-3.13 8.42-7 9.5z"/>
                      </svg>
                    </div>
                    <h3 className="text-2xl font-bold mb-2">Quality</h3>
                    <p className="text-blue-100">Croatian excellence</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Background decoration */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full">
              <div className="w-full h-full border-2 border-orange-200 rounded-3xl transform rotate-6"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;